// extracted by mini-css-extract-plugin
export default {"list":"SavedList_list__D2ABg"};